import {Helmet} from "react-helmet";
import BrandsSections from "../../Sections/Brands";
import Carousel from "../../Sections/Carousel";
import Categories from "../../Sections/Categories";
import Features from "../../Sections/Features";
import FeaturedProducts from "../FeaturedProducts";
import TickerBar from "../../Components/TickerBar";

function Home() {
    return (
        <div className="mt-[80px]">
            <Helmet>
                <title>Meat-House El-Fardos</title>
                <meta
                    name="description"
                    content="متجر Meat House يوفر أفضل أنواع اللحوم مع توصيل سريع للمنازل في مصر."
                />
            </Helmet>
            <Carousel />
            <TickerBar />
            <Categories />
            <BrandsSections />
            <FeaturedProducts serch={false} pagination={false} heading={true} pt={false} />
            <Features />
        </div>
    );
}

export default Home;
